import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#filterByTopic);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#filterByTopic);
    super.disconnectedCallback();
  }

  #filterByTopic = (event) => {
    if (!(event.target instanceof Element)) return;

    const selectedButton = event.target.closest('[data-topic-filter]');
    if (!selectedButton || !this.contains(selectedButton)) return;

    const topic = selectedButton.dataset.topicFilter;
    this.dataset.activeTopic = topic;

    for (const button of this.querySelectorAll('[data-topic-filter]')) {
      button.setAttribute('aria-pressed', String(button === selectedButton));
    }

    let visibleCount = 0;
    for (const article of this.querySelectorAll('.blog-post-item[data-topic]')) {
      article.hidden = topic !== 'all' && article.dataset.topic !== topic;
      if (!article.hidden) visibleCount += 1;
    }

    const status = this.querySelector('[data-topic-status]');
    if (status) status.textContent = `${visibleCount} ${visibleCount === 1 ? 'artículo' : 'artículos'}`;
  };
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
